import CoAppDataGridListCell from "../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../global/components/ThreeDotMenu";

export const roleColumns = ["actions", "name", "users", "permissions"];
export const ssoAndScimEnabledRoleColumns = ["actions", "name", "users", "permissions", "idpgroups"];

export const getRoleManagementColumns = (
	openResourceEditPage,
	duplicateRole,
	handleOpenRoleDeletionDialog,
	organizationSsoAndScim,
	identityProviderName,
	navigationItemReferences,
	loading
) => [
	{
		field: "name",
		headerName: "Name",
		sortable: true,
		editable: false,
		flex: .5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "users",
		headerName: "Users",
		editable: false,
		sortable: false,
		flex: .5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Users" isUser={true} width={225} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "permissions",
		headerName: "Permissions",
		editable: false,
		sortable: false,
		flex: 1.25,
		renderCell: (params) => {
			let permissionsWithFriendlyNames = params.value === "" ? [] : params.value.map(permission => { return { name: permission.friendlyName }; });
			return (
				<CoAppDataGridSkeletonCell
					cellToRender={
						< CoAppDataGridListCell items={permissionsWithFriendlyNames} resource="Permissions" />
					}
					isLoading={loading}
				/>
			);
		}
	},
	...(organizationSsoAndScim
		? [
			{
				field: "idpgroups",
				headerName: identityProviderName ? `${identityProviderName} Groups` : "Groups",
				editable: false,
				sortable: false,
				flex: 1.25,
				renderCell: (params) => (
					<CoAppDataGridSkeletonCell
						cellToRender={<CoAppDataGridListCell items={params.value} resource={identityProviderName ? `${identityProviderName} Groups` : "Groups"} />}
						isLoading={loading}
					/>
				),
			},
		]
		: []),
	{
		field: "actions",
		type: "actions",
		flex: .1,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						<ThreeDotMenu
							options={[
								{
									name: "Edit",
									optionClickHandler: () => {
										openResourceEditPage(params, navigationItemReferences.roleNavItemIndex, "Roles");
									},
								},
								{
									name: "Duplicate",
									optionClickHandler: () => {
										duplicateRole(params.row.id);
									},
								},
								{
									name: "Delete",
									optionClickHandler: () => {
										handleOpenRoleDeletionDialog(params.row);
									},
								},
							]}
						/>
					</div>
				}
				isLoading={loading}
			/>
		),
	},
];